
import React from 'react';
import { PanelContainer } from '../Panel/Panel.styled';

const AffordabilityPanel = () => (
  <PanelContainer id="affordability">
    <div>
      <h2>Affordability</h2>
      <p>Flexible plans for startups.</p>
      {/* Add unique content and layout for Affordability */}
    </div>
  </PanelContainer>
);

export default AffordabilityPanel;
